<template>
  <div class="text-tooltip"
       :style="{width, maxWidth}">
    <el-tooltip
        placement="top"
        popper-class="gj-tooltip--default"
        :disabled="!isShowTooltip"
        :open-delay="400">
      <template #content>
        <slot></slot>
      </template>
      <p class="over-flow" @mouseover="onMouseOver()">
        <span ref="contentSpan"><slot></slot></span>
      </p>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    name: "gj-text",
    props: {
      width: {
        default: null
      },
      maxWidth: {
        default: '100%'
      },
      // 显示的文字内容
      content: {
        type: String,
        default: () => {
          return ''
        }
      }
    },
    data() {
      return {
        isShowTooltip: true
      }
    },
    methods: {
      onMouseOver(str) {
        let parentWidth = this.$refs.contentSpan.parentNode.offsetWidth;
        let contentWidth = this.$refs.contentSpan.offsetWidth;
        this.isShowTooltip = parentWidth < contentWidth;
      }
    }
  }
</script>

<style scoped>
  .text-tooltip {
    display: inline-flex;
  }
  .over-flow {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  p {
    margin: 0;
  }
</style>
